import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { mapCmsNewsToBannerSlide } from '../api/cmsNews';
import { BannerCarousel } from '../components/BannerCarousel';
import { USE_STATIC_SITE_CONTENT } from '../config/staticSiteMode';
import { STATIC_HOME_BANNER_NEWS } from '../data/staticSite/content';
import { Haberler } from '../components/Haberler';
import { PageSeo } from '../components/PageSeo';
import { Projects } from '../components/Projects';
import { Stats } from '../components/Stats';

const HOME_BANNER_LEAD_IMAGE = '/assets/images/home-banner-lead-v2.webp';
const HOME_BANNER_MAX_SLIDES = 4;
const HOME_BANNER_ORDER_NEWS_COUNT = 3;

export function HomePage() {
    const { t, i18n } = useTranslation();
    const [bannerNewsItems, setBannerNewsItems] = useState(
        /** @type {import('../api/cmsNews').CmsNewsItem[] | null} */ (
            USE_STATIC_SITE_CONTENT ? STATIC_HOME_BANNER_NEWS : null
        ),
    );

    const bannerLeadSlide = useMemo(
        () => ({
            id: 'home-banner-lead',
            imageUrl: HOME_BANNER_LEAD_IMAGE,
            title: t('home.banner.leadSlide.title'),
            description: t('home.banner.leadSlide.description'),
            link: '/news',
        }),
        [t, i18n.language],
    );

    useEffect(() => {
        if (USE_STATIC_SITE_CONTENT) {
            setBannerNewsItems(STATIC_HOME_BANNER_NEWS);
            return undefined;
        }

        let cancelled = false;

        /*
        (async () => {
            try {
                const items = await fetchTopCmsNewsByOrder(
                    HOME_BANNER_ORDER_NEWS_COUNT,
                );
                if (cancelled) return;
                setBannerNewsItems(items);
            } catch {
                if (cancelled) return;
                setBannerNewsItems([]);
            }
        })();
        */

        return () => {
            cancelled = true;
        };
    }, []);

    const bannerSlides = useMemo(() => {
        const newsSlides = (bannerNewsItems ?? [])
            .map(mapCmsNewsToBannerSlide)
            .filter((slide) => slide.imageUrl);
        return [bannerLeadSlide, ...newsSlides].slice(0, HOME_BANNER_MAX_SLIDES);
    }, [bannerLeadSlide, bannerNewsItems]);

    const bannerNewsIds = useMemo(
        () => (bannerNewsItems ?? []).map((item) => item.id),
        [bannerNewsItems],
    );

    return (
        <>
            <PageSeo
                title={t('seo.homeTitle')}
                description={t('seo.homeDescription')}
            />
            <div className="home-page">
                <BannerCarousel slides={bannerSlides} />
                <Haberler maxItems={10} excludeNewsIds={bannerNewsIds} />
                <Stats />
                <Projects />
            </div>
        </>
    );
}
